import React from 'react'
import {
  LIVE,
  THEME_DARK,
  LIVE_PURPLE,
  THEME_LIVE_PURPLE,
  THEME_LIVE_PURPLE_DARK,
  THEME_LIVE_WHITE,
} from 'theme/constants'

import { LIVE_PROJECT_ROUTE } from 'routes/constants'

import LiveLogoWhite from 'images/index/live-white.svg'
import LiveLogo from 'images/logos/live.svg'

// Hero
import Live from 'components/Index/Live'

// Live Images
import LiveHeroOneLeft from 'images/projects/live/live-hero-one-left.avif'
import LiveHeroOneRight from 'images/projects/live/live-hero-one-right.webp'
import LiveHeroThreeLeft from 'images/projects/live/live-hero-three-left.webp'
import LiveHeroThreeRight from 'images/projects/live/live-hero-three-right.webp'
import LiveHeroFourLeft from 'images/projects/live/live-hero-four-left.webp'
import LiveHeroFourRight from 'images/projects/live/live-hero-four-right.webp'
import LiveShoppingImage from 'images/projects/live/live-shopping-image.avif'
import LiveOverviewBackgroundImage from 'images/projects/live/live-shape-bg.webp'

const data = {
  id: LIVE,
  name: 'Live',
  route: LIVE_PROJECT_ROUTE,
  general: {
    logo: <LiveLogoWhite />,
    tagline: 'Video; Wherever, whenever',
  },
  theme: {
    primary: THEME_DARK,
  },
  colors: {
    primary: LIVE_PURPLE,
  },
  // Todo: make theme object and use primary and secondary instead of hardcoding theme variables
  hero: {
    theme: LIVE,
    component: <Live />,
    logo: <LiveLogo />,
    slides: [
      {
        key: 'one',
        text: 'Experience the next generation of luxury retail:',
        subText: (
          <>
            <span>Alice + Olivia</span> powered by <span>Live.</span>
          </>
        ),
        images: [
          { key: 'left', image: LiveHeroOneLeft },
          { key: 'right', image: LiveHeroOneRight },
        ],
      },
      {
        key: 'three',
        text: 'Experience the next generation of fitness programming:',
        subText: (
          <>
            <span>In-Shape</span> powered by <span>Live.</span>
          </>
        ),
        theme: LIVE,
        component: <Live />,
        logo: <LiveLogo />,
        images: [
          { key: 'left', image: LiveHeroThreeLeft },
          { key: 'right', image: LiveHeroThreeRight },
        ],
      },
      {
        key: 'four',
        text: 'Experience the next generation of sports training:',
        subText: (
          <>
            <span>Mustard</span> powered by <span>Live.</span>
          </>
        ),
        theme: LIVE,
        component: <Live />,
        logo: <LiveLogo />,
        images: [
          { key: 'left', image: LiveHeroFourLeft },
          { key: 'right', image: LiveHeroFourRight },
        ],
      },
    ],
  },
  overview: {
    isClientStudio: true,
    theme: THEME_LIVE_PURPLE_DARK,
    sector: 'Streaming',
    year: '2020 - Present',
    disciplines: 'Strategy, Product Design, iOS, Web',
    techStack:
      'Swift, SwiftUI, MVVM using Combine, Reactive Programming, Django / Python, React Js, Mux',
    paragraphs: [
      'For years, we’ve seen countless clients struggle building video solutions from scratch. We realized there is a better, faster way to customize and deploy video infrastructure on your own platform.',
    ],
    hasFullWidthImage: true,
    fullWidthImage: LiveShoppingImage,
    backgroundImage: LiveOverviewBackgroundImage,
  },
  conversionAndSales: {
    theme: THEME_LIVE_WHITE,
    title: 'Increase conversion rates and drive incremental sales',
    paragraphs: [
      'Live makes it simple to deploy shoppable video. With just six lines of code, you can engage your community, increase conversion rates, and drive incremental sales with beautiful, shoppable, interactive video.',
    ],
  },
  work: {
    theme: THEME_LIVE_WHITE,
    title: 'Lorem ipsum dolor sit amet, adipiscing elit.',
    paragraphs: [
      'Aenean laoreet neque sed nisi rhoncus ullamcorper. Maecenas facilisis sapien nisl, a tincidunt ligula gravida non. Mauris sapien risus, commodo non accumsan eget, aliquet at risus. Curabitur sed varius dolor. Curabitur pharetra eros sed nulla eleifend, eu imperdiet magna ultrices. Integer auctor euismod lacus, a congue ante.',
      'Ut nisl ex, sodales sit amet scelerisque eget, fermentum sed velit. Nam et congue enim, nec sagittis sapien. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec ut purus accumsan eros sagittis pulvinar vitae eu sem.',
    ],
  },
  results: {
    theme: THEME_LIVE_PURPLE,
    title: (
      <>
        Boost engagement and sales with video delivered by <span>Live.</span>
      </>
    ),
    stats: [
      {
        content: '13',
        description: 'Average minutes spent watching LIVE shopping events',
      },
      {
        content: '25%',
        description:
          'Conversion rate of LIVE shopping events to making a purchase',
      },
      {
        content: '4x',
        description:
          'More revenue generated per minute from LIVE shopping vs Online Store',
      },
    ],
  },
}

export default data
